export default __webpack_public_path__ + "eb492ea5de01c118934081e9ba71770a.png";